import React from 'react';
import {Spin} from 'antd';
import {SearchResultItem} from './SearchResultItem';

interface SearchResultsProps {
  list: any[];
  loadingMore: boolean;
  hasMore: boolean;
  onJumpPath: (item: any) => void;
  total: number | null;
}

export function SearchResults({list, loadingMore, hasMore, onJumpPath, total}: SearchResultsProps) {
  return (
    <>
      <h3 className="drive-search-results__title">
        搜索结果
        {total != null && (
          <span className="drive-search-results__total">
              （共 {total} 条）
            </span>
        )}
      </h3>

      {list.length ? (
        list.map((item: any, index) => (
          <SearchResultItem
            key={`${item.file_md5 || item.root_id || item.directory_id}-${index}`}
            item={item}
            onJumpPath={onJumpPath}
          />
        ))
      ) : (
        <div className="drive-search-results__footer">
          未找到相关文件，试试调整搜索条件或换一组关键词
        </div>
      )}

      {loadingMore && (
        <div className="drive-search-results__footer">
          <Spin size="small"/>
        </div>
      )}

      {!hasMore && list.length > 0 && (
        <div className="drive-search-results__footer">
          没有更多了
        </div>
      )}
    </>
  );
}